module.exports = __webpack_public_path__ + "static/media/close-grey.bc70ef16.svg";